module.exports = __webpack_public_path__ + "media/images/icons/bug-9455acf06795479c8b07ddaa3f6b72da.svg";